export default __webpack_public_path__ + "d5ca196.png";